
<multi-input full :compress="compress">
  <column>
    <div class="sr-only">
      <label :for="month.modelField">{{month.label}}</label>
    </div>
    <a-select
      v-model="document[month.modelField]"
      :placeholder="'Month...'|| month.placeHolder"
      :options="DurationAndTimeHelper.monthOptions"
      @input="monthChange"
      :id="month.modelField"></a-select>
  </column>
  <column>
    <div class="sr-only">
      <label :for="day.modelField">{{day.label}}</label>
    </div>
    <a-select
      v-model="document[day.modelField]"
      :options="daysOptions(document[month.modelField])"
      :placeholder="'Day...'|| day.placeHolder"
      :id="day.modelField"></a-select>
  </column>
</multi-input>
